import React, { Component } from 'react';

const propTypes = {
    progress: React.PropTypes.number.isRequired,
};

const defaultProps = {
};

class Bubbles extends Component {

    constructor(props) {
        super(props);

        this.interval = null;
        this.onTick = this.onTick.bind(this);

        this.state = {
            index: 1,
        };
    }

    componentDidMount() {
        this.interval = setInterval(this.onTick, 30);
    }

    componentWillUnmount() {
        if (this.interval !== null) {
            clearTimeout(this.interval);
        }
    }

    onTick() {
        const index = this.state.index < 24 ? (this.state.index + 1) : 1;
        this.setState({
            index,
        });
    }

    render() {
        const { index } = this.state;
        const className = `sprite loading-${index}`;

        return (
            <div className="loading-bubbles">
                <div className={className} />
            </div>
        );
    }
}

Bubbles.propTypes = propTypes;
Bubbles.defaultProps = defaultProps;

module.exports = Bubbles;



// WEBPACK FOOTER //
// ./js/components/partials/Bubbles.jsx